module.exports = __webpack_public_path__ + "img/brown.be5030ca.webp";